import React from 'react'
import { Row, Col } from 'react-bootstrap'
import companyThumbnail from '../../../../../img/company.png'
import { useSelector } from 'react-redux'
import { SolidButton, FadeButton } from './../../../../library/button'

import './style.scss'

const Index = () => {

	const clientDetails = useSelector(state => state.singleClient.details)
	const loading = useSelector(state => state.singleClient.fetchDetails.loading)

	const renderCustomerType = type => {
		if(type === "company"){
			return <span><i class="fad fa-building"></i> Bedriftskunde</span>
		} else {
			return <span><i class="fad fa-user"></i> Personkunde</span>
		}
	}

	const renderCustomerDisplay = type => {
		if(type === "company"){
			if(!loading && clientDetails.general && clientDetails.general.name){
				return clientDetails.general.name
			}
		} else {
			if(!loading && clientDetails.general && clientDetails.general.firstName && clientDetails.general.lastName){
				return `${clientDetails.general.firstName} ${clientDetails.general.lastName}`
			}
		}
	}

	const renderCallButton = () => {
		if(loading){
			return <SolidButton color="blue" title="Laster" icon={<i class="fad fa-phone"></i>}/>
		} else {
			if(clientDetails && clientDetails.contact && clientDetails.contact.phone){
				return(
					<a href={`tel:${clientDetails.contact.phone ? clientDetails.contact.phone:""}`}>
						<SolidButton color="blue" title="Ring" icon={<i class="fad fa-phone"></i>}/>
					</a>
				)
			} else {
				return <SolidButton disabled color="blue" title="Ring" icon={<i class="fad fa-phone"></i>}/>
			}
		}
	}

	const renderEmailButton = () => {
		if(loading){
			return <FadeButton color="blue" spacing='left' title="Laster" icon={<i class="fad fa-envelope"></i>}/>
		} else {
			if(clientDetails && clientDetails.contact && clientDetails.contact.email){
				return(
					<a href={`mailto:${clientDetails.contact.email ? clientDetails.contact.email:""}`}>
						<FadeButton color="blue" spacing='left' title="E-post" icon={<i class="fad fa-envelope"></i>}/>
					</a>
				)
			} else {
				return <FadeButton disabled color="blue" spacing='left' title="E-post" icon={<i class="fad fa-envelope"></i>}/>
			}
		}
	}

	const renderSpinner = () => {
		if(loading){
			return <i className="fas fa-circle-notch fa-spin"></i>
		} else {
			return null
		}
	}

	const renderCompanyName = () => {
		if(loading){
			return " Laster inn"
		} else {
			return renderCustomerDisplay(clientDetails.type)
		}
	}

	return(
		<Row className="company-information-row">
			<Col className="thumbnail-col">
				<img className="company-thumbnail" src={!loading && clientDetails.logoUrl ? clientDetails.logoUrl:companyThumbnail}/>
			</Col>
			<Col className="information-col">
				<h3 className="company-title">{renderSpinner()} {renderCompanyName()}</h3>
				<p className="company-description">{loading && "Laster inn"} {!loading && renderCustomerType(clientDetails.type)} {!loading && !clientDetails.type && "Utilgjengelig"}</p>
        		<div className="company-actions-container">
					{renderCallButton()}
					{renderEmailButton()}
					{!loading && clientDetails.social && clientDetails.social.facebook ?
						<a href={`${clientDetails.social.facebook ? clientDetails.social.facebook:""}`}><button className="facebook-button active"><i class="fab fa-facebook-f"></i></button></a>
						:
						<button className={"facebook-button disabled"}><i class="fab fa-facebook-f"></i></button>
					}
					{!loading && clientDetails.social && clientDetails.social.twitter ?
						<a href={`${clientDetails.social.twitter ? clientDetails.social.twitter:""}`}><button className="twitter-button active"><i class="fab fa-twitter"></i></button></a>
						:
						<button className={"twitter-button disabled"}><i class="fab fa-twitter"></i></button>
					}
					{!loading && clientDetails.contact && clientDetails.contact.website ?
						<a target="_blank" rel="noopener noreferrer" href={`${clientDetails.contact.website ? clientDetails.contact.website:""}`}><button className="link-button active"><i class="fas fa-link"></i></button></a>
						:
						<button className={"link-button disabled"}><i class="fas fa-link"></i></button>
					}
        		</div>
			</Col>
		</Row>
	)
}

export default Index




